import { gql } from 'graphql-request'

export const CANCEL_EXPORT_JOB = gql`
  mutation CancelExportJob($cancelExportInput: CancelExportJobInput!) {
    cancelExportJob(cancelExportInput: $cancelExportInput)
  }
`
